export default __webpack_public_path__ + "media/images/fleche-iso-fad0e63852047515c207c83cc90f5ae7.png";